import { axiosInstance } from './api';

export interface TelegramSettingsDto {
  id: number;
  zone: string | null;
  prod_chat_id: string;
  prod_thread_id: string | null;
  // Only present when the current user has configure_system_chats permission (superusers)
  debug_chat_id?: string;
  cancel_chat_id?: string;
  can_configure_system_chats: boolean;
}

export const getTelegramSettings = (zoneId: string) =>
  axiosInstance.get<TelegramSettingsDto>(`/telegram_messages/settings/${zoneId}/`);

export const initTelegramSettings = (zoneId: string) =>
  axiosInstance.post<TelegramSettingsDto>(`/telegram_messages/settings/${zoneId}/`);

export const patchTelegramSettings = (
  zoneId: string,
  data: {
    prod_chat_id?: string;
    prod_thread_id?: string | null;
    debug_chat_id?: string;
    cancel_chat_id?: string;
  },
) => axiosInstance.patch<TelegramSettingsDto>(`/telegram_messages/settings/${zoneId}/`, data);
